import { useEffect, useState } from 'react'
import {
  COUNTDOWN_REFRESH_MS,
  computeDeadlineCountdown,
  type DeadlineCountdown,
} from './deadlineCountdown'
import type { Game } from '../../types'

/** The once-a-minute clock behind the header's deadline line. All the
 *  threshold/format rules live in `deadlineCountdown.ts`; this only supplies "now".
 *
 *  "Now" is the *server's* now: `/api/football/live` returns `serverTime` for
 *  exactly this purpose, and `useLivePoll` turns it into an offset at the instant each poll
 *  lands — the only moment both clocks are in hand. Adding it here means a device whose clock is
 *  ten minutes fast reaches zero when the server starts rejecting, not ten minutes early.
 *  `serverOffsetMs` is 0 until the first poll lands, which counts down off the local clock as
 *  before. */
export function useDeadlineCountdown(
  games: Game[],
  deadlinePassed: boolean,
  serverOffsetMs = 0
): DeadlineCountdown {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const intervalId = setInterval(() => setNow(Date.now()), COUNTDOWN_REFRESH_MS)
    return () => clearInterval(intervalId)
  }, [])

  return computeDeadlineCountdown(games, now + serverOffsetMs, deadlinePassed)
}
